import { Paper, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ItemDisplay } from '../../../components/itemDisplay';
import { LoanDetailsAccordion } from './loanDetailsAccordion';
import { formatCurrency, formatPercentage } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { QuoteTypeStore } from '../../../stores/quoteTypeStore';

const useStyles = makeStyles(theme => ({
  paper: {
    border: `1px solid lightgray`,
    borderRadius: '16px !important',
    padding: theme.spacing(4),
  },
}));

interface LoanDetailsCardProps {
  store: QuoteTypeStore;
}

export const LoanDetailsCardSingleProperty = observer(
  ({ store }: LoanDetailsCardProps) => {
    const classes = useStyles();
    const { pricerSummaryStore, loanDetailsStore } = store;
    const { pricerLoanTerms, submittedPricingOption } = pricerSummaryStore;
    const { loanPurpose, rateType, formValues } = submittedPricingOption;
    const { loanToValue } = formValues

    const color = store.loanEconomicsStore.enableManualQuote
      ? '#FC5E5E'
      : '#34A853';

    return (
      <Paper className={classes.paper} elevation={0}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              justifyContent="space-between"
              style={{ paddingInline: '240px' }}
            >
              <Grid item>
                <ItemDisplay
                  label="Total Loan Amount"
                  value={formatCurrency(pricerLoanTerms.amount)}
                  valueTextColor={color}
                />
              </Grid>
              <Grid item>
                <ItemDisplay
                  label="Loan To Value"
                  value={formatPercentage(loanToValue)}
                  valueTextColor={color}
                />
              </Grid>
              <Grid item>
                <ItemDisplay
                  label="Quote Type"
                  value={loanPurpose}
                  valueTextColor={color}
                />
              </Grid>
              <Grid item>
                <ItemDisplay
                  label="Rate Type"
                  value={rateType}
                  valueTextColor={color}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <LoanDetailsAccordion store={store} />
          </Grid>
        </Grid>
      </Paper>
    );
  }
);
